const EVENT_NAME = "criteoAdvertDeliveryDecision";

const recordDeliveryDecision = ({
  deliveryAttempted,
  painted,
  isSorted,
  sponsoredProductIdsCount,
  pageNumber,
  isSearchPage,
  consentC0004,
  reason,
}) => {
  window.NREUM?.addPageAction?.(EVENT_NAME, {
    deliveryAttempted,
    painted,
    isSorted,
    sponsoredProductIdsCount,
    pageNumber,
    isSearchPage,
    consentC0004,
    reason,
  });
};

export default recordDeliveryDecision;
